module.exports = __webpack_public_path__ + "img/topic1-b.ec2d8d6e.jpg";